import Router from 'next/router';
import React from 'react';

import { AttributeStringModel } from '@/models';

import TagDS, { TagDSProps } from '@/components/common/ds-tag/Tag.ds';

import styles from './ProductTagList.module.scss';

export type ProductTagListProps = {
  t: (key: string) => string;
  promotion?: AttributeStringModel;
  infoSiteLabel?: string;
  className?: string;
  lightPrice?: boolean;
  children?: React.ReactNode;
}

const ProductTagList = ({
  t,
  promotion,
  infoSiteLabel,
  className,
  lightPrice,
  children
}: ProductTagListProps) => {
  const hasTags = promotion?.value || infoSiteLabel || lightPrice || children;

  if (!hasTags) return null;

  const classNames = [styles.tags, className].filter(Boolean).join(' ');

  const renderPromotionTag = () => {
    if (!promotion?.value) return null;

    let promoTagProps: TagDSProps = {
      content: promotion?.value,
      size: 'sm',
      color: 'promo',
      state: 'secondary',
      type: 'passive'
    };

    if (promotion?.url) {
      promoTagProps = {
        ...promoTagProps,
        state: 'secondary',
        type: 'navigation',
        onClick: () => Router.push(promotion?.url)
      };
    }

    return <TagDS {...promoTagProps} />;
  };

  return (
    <div className={classNames} data-test-id="tags">
      {renderPromotionTag()}

      {!promotion?.value && lightPrice && (
        <TagDS
          content={t('product.lightPrice')}
          type={'passive'}
          size={'sm'}
          color={'promo'}
          state={'secondary'}
        />
      )}

      {infoSiteLabel && (
        <TagDS
          content={infoSiteLabel}
          type={'passive'}
          size={'sm'}
          color={'promo'}
          state={'secondary'}
        />
      )}

      {children}
    </div>
  );
};

export default ProductTagList;
